export { useCopyToClipboard } from './useCopyToClipboard';
//# sourceMappingURL=index.js.map